import React, { useContext } from "react";
import { LayoutContext, constants } from "./LayoutContext";

export const LeftSide = () => {
  const layoutContext = useContext(LayoutContext);

  const { theme } = layoutContext;

  return (
    <div
      className={theme === constants.THEME_LIGHT ? "theme-light" : "theme-dark"}
      id="left-side"
    ></div>
  );
};
